/**
 * Who is an admin by email, until Clerk metadata is set for every admin.
 * One list: the sign-in context (contexts/AuthContext.tsx) and the admin
 * People table (tier column) both read it, so they cannot disagree.
 */
const ADMIN_EMAILS = [
  'guillaume.beauchamp',          // Guillaume Beauchamp
  'nicholas.charland',            // Nicholas Charland
  'ncharlandarmstrong@gmail.com', // Nicholas Charland-Armstrong
  'shakim01234@gmail.com',        // Mishka
];

export function isAdminEmail(email: string | null | undefined): boolean {
  const e = (email ?? '').toLowerCase();
  if (!e) return false;
  return ADMIN_EMAILS.some((admin) => e === admin || e.startsWith(admin));
}
